import { BancoPagamento } from './../../../../financeiro/domain/models/banco_pagamento';
import { CentroCusto } from './../../../../comercial/domain/models/centro_custo';
import dayjs from "dayjs";
import { IGetReportContasPagarAnaliticoUseCase } from "../../../presentation/useCases/read/get_report_contas_pagar_analitico_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../models/report_data";

export type GetReportContasPagarAnaliticoParams = {
  requiredMimeType: ReportMimeType | null;
  centroCusto?: number[] | null;
  subconta?: number[] | null;
  titulo?: string | null;
  fornecedor?: number[] | null;
  ordemCompra?: number[] | null;
  dataPagarDe?: Date | null;
  dataPagarAte?: Date | null;
  dataPagoDe?: Date | null;
  dataPagoAte?: Date | null;
  status?: number[] | null;
  tipoConta?: string | null;
  nro?: string | null;
  notaFiscal?: string | null;
  responsavel?: number[] | null;
  funcionarioFolha?: number[] | null;
  idUsuario?: number | null;
  medicao?: number[] | null;
  produtosServicos?: number[] | null;
  formaPagamento?: number[] | null;
  dataCriacaoDe?: Date | null;
  dataCriacaoAte?: Date | null;
  dataCompetenciaDe?: Date | null;
  dataCompetenciaAte?: Date | null;
  bancoPagamento?: number[] | null;
  ordenacao?: number | null;
  colunas?: {
    nroContasPagar: boolean;
    centroCusto: boolean,
    ordemCompra: boolean,
    fornecedor: boolean,
    bancoPagamento: boolean,
    notaFiscal: boolean,
    nroDocumento: boolean,
    responsavel: boolean,
    status: boolean,
    titulo: boolean,
    subconta: boolean,
    dataPagar: boolean,
    dataPago: boolean,
    valorPagar: boolean,
    valorPago: boolean,
    funcionarioFolha: boolean,
    contaBancaria: boolean,
    observacao: boolean,
    notaFiscalEspecial: boolean,
    bdi: boolean,
    nroMedicao: boolean,
    totalBdi: boolean,
    formaPagamento: boolean,
    informacaoGeral: boolean,
    bdi2: boolean,
    totalBdi2: boolean,
    dataCriacao: boolean,
    dataCompetencia: boolean

    // ordenacao: boolean,
  } | null
};


export class GetReportContasPagarAnaliticoUseCase implements IGetReportContasPagarAnaliticoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(params: GetReportContasPagarAnaliticoParams): Promise<ReportData> {

    const centroCustoStr = params.centroCusto ? params.centroCusto.filter(x => x !== 0).join(',') : null;
    const subcontaStr = params.subconta ? params.subconta.filter(x => x !== 0).join(',') : null;
    const fornecedorStr = params.fornecedor ? params.fornecedor.filter(x => x !== 0).join(',') : null;
    const ordemCompraStr = params.ordemCompra ? params.ordemCompra.filter(x => x !== 0).join(',') : null;
    const statusStr = params.status ? params.status.filter(x => x !== 4).join(',') : null;
    const responsavelStr = params.responsavel ? params.responsavel.filter(x => x !== 0).join(',') : null;
    const funcionarioFolhaStr = params.funcionarioFolha ? params.funcionarioFolha.filter(x => x !== 0).join(',') : null;
    const medicaoStr = params.medicao ? params.medicao.filter(x => x !== 0).join(',') : null;
    const produtosServicosStr = params.produtosServicos ? params.produtosServicos.filter(x => x !== 0).join(',') : null;
    const formaPagamentoStr = params.formaPagamento ? params.formaPagamento.filter(x => x !== 0).join(',') : null;
    const bancoPagamentoStr = params.bancoPagamento ? params.bancoPagamento.filter(x => x !== 0).join(',') : null;

    const response = await this.repository.getReportContasPagarAnalitico({
      centroCusto: centroCustoStr,
      subconta: subcontaStr == "" ? null : subcontaStr,
      titulo: params.titulo || null,
      fornecedor: fornecedorStr == "" ? null : fornecedorStr,
      ordemCompra: ordemCompraStr == "" ? null : ordemCompraStr,
      dataPagarDe: params.dataPagarDe || null,
      dataPagarAte: params.dataPagarAte || null,
      dataPagoDe: params.dataPagoDe || null,
      dataPagoAte: params.dataPagoAte || null,
      status: statusStr == "" ? null : statusStr,
      tipoConta: params.tipoConta || null,
      nro: params.nro || null,
      notaFiscal: params.notaFiscal || null,
      responsavel: responsavelStr == "" ? null : responsavelStr,
      funcionarioFolha: funcionarioFolhaStr == "" ? null : funcionarioFolhaStr,
      idUsuario: params.idUsuario || null,
      medicao: medicaoStr == "" ? null : medicaoStr,
      produtosServicos: produtosServicosStr == "" ? null : produtosServicosStr,
      formaPagamento: formaPagamentoStr == "" ? null : formaPagamentoStr,
      dataCriacaoDe: params.dataCriacaoDe || null,
      dataCriacaoAte: params.dataCriacaoAte || null,
      dataCompetenciaDe: params.dataCompetenciaDe || null,
      dataCompetenciaAte: params.dataCompetenciaAte || null,
      requiredMimeType: params.requiredMimeType,
      bancoPagamento: bancoPagamentoStr == "" ? null : bancoPagamentoStr,
      ordenacao: params.ordenacao || 0,
      colunas: params.colunas || null,
    })

    if (response.mimeType !== 'text/html') {
      const arquivoData = response.bytes;
      const arquivoNome = `contas_pagar_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
